/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable react-refresh/only-export-components */
import React from "react";
import { TableRow, TableSortLabel, Box, TableHead, styled, TableCell, tableCellClasses } from "@mui/material";
import { visuallyHidden } from '@mui/utils';
import {IPropsTableHead, HeadCell, ColumnTypes, ETABLE} from './ITabelas';

function TableListaHead(props: IPropsTableHead)
{
	const { order, orderBy, tipo, onRequestSort } = props;	

	const createSortHandler = (property: ColumnTypes) => (event: React.MouseEvent<unknown>) =>
	{
		onRequestSort(event, property);
	};

	const isActive = (headCellId: string, indice: number): boolean => {
		if(orderBy === headCellId) return true;
		if(orderBy === undefined && indice === 0) return true;
		else false
	};

	return <>
		<TableHead
			sx={{backgroundColor: '#132190'}}
		>
			<TableRow>
			{props.setup.map((headCell:HeadCell,keyHead) => (
					<StyledTableCell
						sx={{ textAlign: headCell.align || 'center' }}
						key={keyHead}
						align={ headCell.numeric ? 'right' : 'left' }
						colSpan={ headCell.colSpan ? headCell.colSpan : 1 }
						sortDirection={headCell.sort && orderBy === headCell.id ? order : false}
					>
					{
						headCell.sort ?
							<TableSortLabel
								active={isActive(headCell.id as string, keyHead)}
								direction={orderBy === headCell.id ? order : 'asc'}
								onClick={headCell.sort ? createSortHandler(headCell.id as string) : () => {}}
								sx={{
									textAlign: headCell.align || 'center',
									color: "#fff !important",
									'& .MuiTableSortLabel-icon': {
										color: '#fff !important',
									},
									'&.Mui-active': {
										color: "#fff !important",
										'& .MuiTableSortLabel-icon': {
											color: '#fff !important',
										},
									},
								}}
							>
								{tipo === ETABLE.PROGRAMAS && headCell.id === "classificacaoEtaria" ? 'Classif. etária' : headCell.label}
								{
									(headCell.sort && orderBy === headCell.id) &&
										<Box component="span" sx={visuallyHidden}>
											{order === 'desc' ? 'sorted descending' : 'sorted ascending'}
										</Box>
								}
							</TableSortLabel>
						:
							tipo === ETABLE.PROGRAMAS && headCell.id === "classificacaoEtaria" ? 'Classif. etária' : headCell.label
					}
					</StyledTableCell>
				))
			}
			{
				props.action &&
					<StyledTableCell align={'center'} colSpan={props.action.length}>Ações</StyledTableCell>
			}
			</TableRow>
		</TableHead>
	</>
}

export default TableListaHead;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: theme.palette.secondary.main,
		color: theme.palette.secondary.contrastText,
		[`&.${tableCellClasses.head}:hover span`]: {
			color: theme.palette.secondary.contrastText,
		},
	},
	[`&.${tableCellClasses.body}`]: {
	},
}));
